<template>
  <v-container class="text-center">
    <v-row>
      <v-col algin="center">
        <img class="icon" src="@/assets/title.png" width="270" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  // props: {
  //   size: Number
  // }
  // computed: {
  //   iconWidth: vm => (96 / 4) * vm.size,
  //   titleClass: vm => `display-${vm.size - 1} primary--text`
  // }
}
</script>

<style lang="scss" scoped>
.icon {
  vertical-align: middle;
}
</style>
